import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import FundFriendsPrivacy from './FundFriendsPrivacy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/fund-privacy-policy" element={<FundFriendsPrivacy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
